
import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import FetchForms from '../utils/FetchForms';
import { Database } from '../services/serviceDB';

export default function Download() {
    const [formID, setFormID] = useState<any>({});
    const [formName, setFormName] = useState<any>({});

    
    const childToParent = (childdata) => {
      setFormID(childdata._id)
      setFormName(childdata.form_name)
    }

    
    const exportToCSV = (event) => {
        event.preventDefault()
        var ResultDB = new Database("results", false)

        var limitation = event.target.elements["limit"].value
        var sorting = event.target.elements["date_sorting"].value

        ResultDB.remote_database.createIndex({
            index: {fields: ['posted_at']}
          });
          
        let query = {
            selector: {
                posted_at: {'$gte': null},
                form_id: formID,
            },
            limit: Number(limitation),
            sort: [{posted_at: sorting}]
        }

        console.log(query)
        ResultDB.remote_database.find(query).then((result: { docs: any; }) => {
            const data = result.docs;
            const csv = Papa.unparse(data);
            const link = document.createElement('a');
            link.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
            const today = new Date().toISOString().slice(0, 10);
            link.download = today+'_'+formName+'_data.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }
      

    return (
        <>
        {FetchForms({childToParent}, false, true)}
        <form onSubmit={exportToCSV}>
            <label htmlFor="limit"><b>Nombre de documents maximum</b></label>
            <input type="number" name="limit" defaultValue={50000}/>
            <label htmlFor="date_sorting"><b>Trier par date</b></label>
            <select name="date_sorting">
                <option value="asc">Ascendant</option>
                <option value="desc">Descendant</option>
            </select>
            <input type="submit" value="Exporter en CSV"/>
        </form>
        </>
    )
};
